import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendToWhatsApp = (e) => {
    e.preventDefault();
    const phoneNumber = "94761007063"; 
    const currentTime = new Date().toLocaleString();
    
    const text = 
      `🏛️ *OFFICIAL WEB INQUIRY | VIDULAKA MATALE*%0A` +
      `_____________________________________%0A%0A` +
      `📅 *Date/Time:* ${currentTime}%0A%0A` +
      `👤 *APPLICANT DETAILS*%0A` +
      `• *Name:* ${formData.name}%0A` +
      `• *Email:* ${formData.email}%0A%0A` +
      `📌 *SUBJECT:*%0A${formData.subject}%0A%0A` +
      `💬 *INQUIRY MESSAGE:*%0A${formData.message}%0A%0A` +
      `_____________________________________%0A` +
      `_Sent via Vidulaka Official Web Portal_`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${text}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="contact" className="py-12 md:py-20 bg-slate-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        
        {/* Header - Mobile friendly font sizes */}
        <div className="text-center mb-8 md:mb-12">
          <motion.h2 
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-red-600 font-bold uppercase tracking-widest text-[10px] md:text-xs mb-2"
          >
            Direct Access
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-3xl md:text-5xl font-black text-indigo-950 leading-tight"
          >
            Consult Our<span className="text-red-600"> Academic Experts</span>
          </motion.p>
        </div>

        {/* Main Container - Mobile එකේදී grid-cols-1, Desktop එකේදී grid-cols-2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-white p-3 md:p-6 rounded-[2.5rem] md:rounded-[3rem] shadow-xl border border-gray-100 min-h-fit lg:h-[600px]">
          
          {/* Form Side */}
          <div className="p-4 md:p-8 flex flex-col justify-center order-2 lg:order-1">
            <div className="flex items-center mb-6 justify-center lg:justify-start">
                <div className="w-1.5 h-8 bg-red-600 rounded-full mr-4 hidden md:block"></div>
                <h3 className="text-xl md:text-2xl font-extrabold text-indigo-950 tracking-tight text-center lg:text-left">Official Inquiry Portal</h3>
            </div>
            
            <form className="space-y-4" onSubmit={sendToWhatsApp}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="text-[10px] font-black text-indigo-900/40 uppercase ml-1 tracking-widest">Full Name</label>
                  <input name="name" type="text" placeholder="Your Name" required onChange={handleChange}
                    className="w-full px-5 py-3.5 rounded-xl bg-gray-50 border-2 border-transparent focus:border-red-600 outline-none transition-all font-semibold text-sm shadow-sm" />
                </div>
                
                <div className="space-y-1">
                  <label className="text-[10px] font-black text-indigo-900/40 uppercase ml-1 tracking-widest">Email Address</label>
                  <input name="email" type="email" placeholder="Email" required onChange={handleChange}
                    className="w-full px-5 py-3.5 rounded-xl bg-gray-50 border-2 border-transparent focus:border-red-600 outline-none transition-all font-semibold text-sm shadow-sm" />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-black text-indigo-900/40 uppercase ml-1 tracking-widest">Inquiry Subject</label>
                <input name="subject" type="text" placeholder="Ex: Registration, Class Fees" required onChange={handleChange}
                  className="w-full px-5 py-3.5 rounded-xl bg-gray-50 border-2 border-transparent focus:border-red-600 outline-none transition-all font-semibold text-sm shadow-sm" />
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-black text-indigo-900/40 uppercase ml-1 tracking-widest">Message</label>
                <textarea name="message" placeholder="Type your message here..." rows="3" required onChange={handleChange}
                  className="w-full px-5 py-3.5 rounded-xl bg-gray-50 border-2 border-transparent focus:border-red-600 outline-none transition-all resize-none font-semibold text-sm shadow-sm"></textarea>
              </div>
              
              <button type="submit"
                className="w-full bg-[#25D366] text-white font-black py-4 rounded-xl hover:bg-[#1ebc5a] shadow-lg shadow-green-200 transition-all transform hover:-translate-y-1 active:scale-95 flex items-center justify-center space-x-3 text-md mt-4"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512">
                  <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-5.5-2.8-23.2-8.5-44.2-27.2-16.4-14.6-27.4-32.7-30.6-38.2-3.2-5.6-.3-8.6 2.5-11.3 2.5-2.5 5.6-6.5 8.3-9.7 2.8-3.3 3.7-5.6 5.6-9.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 13.2 5.8 23.5 9.2 31.5 11.8 13.3 4.2 25.4 3.6 35 2.2 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                </svg>
                <span className="font-bold">Chat on WhatsApp</span>
              </button>
            </form>
          </div>

          {/* Map Side - Order changed for better flow on mobile */}
          <div className="h-[250px] sm:h-[350px] lg:h-full rounded-[2rem] md:rounded-[2.5rem] overflow-hidden shadow-inner relative border-4 border-white order-1 lg:order-2">
             <iframe 
              title="Vidulaka Matale"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3954.8415654522436!2d80.62125031024505!3d7.482759911855673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae359002e1b8277%3A0x86987f7396655c65!2sVidulaka%20Institute!5e0!3m2!1sen!2slk!4v1700000000000!5m2!1sen!2slk" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;